import axios from 'axios'
import { NRLogger } from '../../modules/logging/nrLogging'

export default class CallMeService {
  async getCallMeSchedule(tenant, locale, segment, config) {
    return await this.getCallMeInfo(tenant, locale, segment, config)
  }

  async getCallMeInfo(tenant, locale, segment, config) {
    const url = `${config.gcpApi}/v3/channels/phone`
    const params = {
      tenant,
      locale,
      segment,
    }

    const result = await axios({
      method: 'get',
      url,
      params,
      headers: {
        Accept: 'application/json',
        'X-Api-Key': config.gcpApiKey,
      },
    })
      .then(function (response) {
        // handle success
        NRLogger.info('UBIK Help Center - Get Phone', {
          tenant,
          locale,
          url,
          segment,
          status: response.status,
        })
        return response.data
      })
      .catch(function (error) {
        NRLogger.error('UBIK Help Center - Get Phone', {
          tenant,
          locale,
          url,
          segment,
          status: error.response?.status,
          message: 'Error occurred while retrieving phone data',
          stack: JSON.stringify(error),
        })

        return {}
      })
    return result
  }
}
